module.exports = __webpack_public_path__ + "static/media/white_pen.0b219bbb.svg";